import { render, staticRenderFns } from "./left-menu.vue?vue&type=template&id=54d2959f&"
import script from "./left-menu.vue?vue&type=script&lang=js&"
export * from "./left-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports